























































import {
  getIresDeviceCategory,
  getIresDeviceCategoryFromSerialNumber,
  getIresDeviceDisplayName,
  IresDevice,
  IresDeviceCategory,
  isActiveProgramChainOfIresDevice,
} from "@/data/models/IresDevice";
import Panel from "@/data/models/Panel";
import { getConfigForPanelType, PanelConfig } from "@/data/models/PanelConfig";
import {
  getProjectAssignmentDetailsOfProgramChain,
  matchesMinProgramChainDuration,
  matchesDeviceAssignmentDetails,
  ProgramChain,
  filterRunsWithCorrectProgramNumber,
} from "@/data/models/ProgramChain";
import { ProjectAssignmentDetails, getProjectAssignmentDetailsFromClientPanelAssignments } from "@/data/models/ProjectAssignmentInfo";
import { getCurrentProjectAssignmentDetails } from "@/data/repository/ClientPanelRepository";
import { getIresDevice } from "@/data/repository/IresDeviceRepository";
import { loadProgramChains } from "@/data/repository/ProgramChainRepository";
import router from "@/router/router";
import { PanelConfigModule } from "@/store/modules/PanelConfigModule";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { StateChanger } from "vue-infinite-loading";
import { Vue, Component } from "vue-property-decorator";
import DryingInfoItemComponent from "./DryingInfoItem.vue";
import { DryingInfoItem } from "./IresDeviceDetail.vue";
import { getAllAssignmentsOfCurrentClient, getAllAssignmentsOfMemberClients } from "@/data/repository/IresDeviceAssignmentRepository";
import { getMemberClientPanelAllAssignments, getClientPanelAllAssignments } from "@/data/repository/ClientPanelAssignmentRepository";
import { IresDeviceAssignment } from "@/data/models/IresDeviceAssignment";
import { ClientPanelAssignment } from "@/data/models/ClientPanelAssignment";
import { getClientId, getMemberClientIds } from "@/data/repository/ClientRepository";
import { getMinProgramChainDurationInMin } from "@/data/repository/SettingsRepository";
import { calculateBackgroundStyle, StorageKeyLastVisitedItemLevel } from "@/utils/Utils";
import { 
  viewDryingHistoryOfMemberAccess,
  viewDryingHistoryOfAllClientsAccess 
} from "@/permissions/UserPermissions";
import { 
  viewProgramChainsOfAllClientsClientAccess,
  viewProgramChainsWithUndefinedProgramNumber,
} from "@/permissions/ClientPermissions";
import { getEffectiveUser } from "@/utils/ViewAs";

@Component({
  name: "DryingHistoryComponent",
  components: {
    "drying-info-item": DryingInfoItemComponent,
  },
})
export default class DryingHistoryComponent extends Vue {
  isLoading = false;
  canLoadMoreProgramChains = false;

  iresDevice: IresDevice | null = null;
  nextPaginationDate: Date | undefined = undefined;

  programChains: ProgramChain[] = [];

  programChainNumberLookup = new Map<number, number>();

  isShowing = false;
  showSensorInfo = false;

  currentProjectAssignmentDetails: ProjectAssignmentDetails | null = null;
  iresDeviceAssignments: IresDeviceAssignment[] = [];
  clientPanelAssignments: ClientPanelAssignment[] = [];
  config: PanelConfig | null = null;

  showNoHistoryHint = false;
  forceUpdateBackgroundColor = false;

  historyNotAvailable = false;

  /** The user whose view this shows: the chosen one while "Sicht auf" is active (ticket 2610052). */
  get activeUser() {
    return getEffectiveUser();
  }

  get isAllowedToViewProgramChainsOfAllClients() {
    return viewProgramChainsOfAllClientsClientAccess();
  }

  get isAllowedToViewProgramChainsWithUndefinedProgramNumber() {
    return viewProgramChainsWithUndefinedProgramNumber();
  }

  get assignedClientId() {
    return this.iresDevice?.currentAssignment?.clientId;
  }

  get isAllowedToViewDryingHistoryOfAllClients() {
    return viewDryingHistoryOfAllClientsAccess(this.activeUser);
  }

  get isAllowedToViewDryingHistoryOfMemberClients() {
    const activeUser = getEffectiveUser();

    return viewDryingHistoryOfMemberAccess(activeUser) && this.isMemberClient;
  }

  get isIresDeviceAssignedToClient() {
    const clientId = getClientId();

    return this.iresDeviceAssignments.find((assignment) => assignment.clientId === clientId);
  }

  get isMemberClient() {
    return this.assignedClientId ? this.memberClientIds.includes(this.assignedClientId) : false;
  }

  get memberClientIds() {
    return getMemberClientIds();
  }

  onOpenProgramChainDetails(programChain: ProgramChain) {
    this.forceUpdateBackgroundColor = !this.forceUpdateBackgroundColor;

    router.push({
      path: `deviceDetail`,
      query: {
        ...router.currentRoute.query,
        chainId: programChain.id,
      },
    });
  }

  onOpenProjectDetails(projectId: string) {
    this.forceUpdateBackgroundColor = !this.forceUpdateBackgroundColor;
    
    router.push({
      path: `/main/projects/${projectId}`,
      params: {
        projectId: projectId,
      },
    });
  }

  async created() {
    const serialNumber = router.currentRoute.query["serialNumber"] as string;
    this.iresDevice = await getIresDevice(serialNumber, true);

    if (this.isAllowedToViewDryingHistoryOfMemberClients && this.assignedClientId) {
      this.iresDeviceAssignments = await getAllAssignmentsOfMemberClients(serialNumber);
      this.clientPanelAssignments = await getMemberClientPanelAllAssignments(this.iresDevice.serialNo, this.assignedClientId);
    }
    else {
      this.iresDeviceAssignments = await getAllAssignmentsOfCurrentClient(serialNumber, getClientId());
      this.clientPanelAssignments = await getClientPanelAllAssignments(this.iresDevice.serialNo);
    }

    if (
      !this.isIresDeviceAssignedToClient && 
      !this.isAllowedToViewDryingHistoryOfAllClients && 
      !this.isAllowedToViewDryingHistoryOfMemberClients
    ) {
      this.historyNotAvailable = true;
      return;
    }

    ToolbarContentModule.setToolbarTitle(this.title);

    const iresDeviceCategory = getIresDeviceCategoryFromSerialNumber(
      serialNumber
    );

    if (iresDeviceCategory === IresDeviceCategory.PANEL) {
      this.config = await this.loadPanelConfig();
    }

    this.currentProjectAssignmentDetails =
      (await getCurrentProjectAssignmentDetails(serialNumber, this.isAllowedToViewDryingHistoryOfMemberClients ? this.assignedClientId : undefined)) ?? null;

    this.canLoadMoreProgramChains = true;

    setTimeout(() => {
      this.showNoHistoryHint = true;
    }, 500);
  }

  activated() {
    ToolbarContentModule.setToolbarTitle(this.title);
  }

  async loadPanelConfig() {
    const panel = this.iresDevice as Panel;

    try {
      const configOnPanel = await PanelConfigModule.loadConfig(
        panel.configurationName
      );

      if (configOnPanel && getConfigForPanelType(configOnPanel, panel)) {
        return configOnPanel;
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  get title() {
    if (!this.iresDevice) {
      return "";
    }

    const iresDeviceCategory = getIresDeviceCategory(this.iresDevice);

    return this.$t(
      `dryingHistory.formatDryingHistory${
        iresDeviceCategory === IresDeviceCategory.COMBOX ? "Box" : "Panel"
      }`,
      [getIresDeviceDisplayName(this.iresDevice)]
    ).toString();
  }

  get dryingInfoItems(): DryingInfoItem[] {
    const minProgramChainDuration = getMinProgramChainDurationInMin();

    return this.programChains
      .filter((programChain) =>
        matchesMinProgramChainDuration(programChain, minProgramChainDuration) &&
        (
          matchesDeviceAssignmentDetails(programChain, this.iresDeviceAssignments) ||
          this.isAllowedToViewProgramChainsOfAllClients
        ) &&
        (
          filterRunsWithCorrectProgramNumber(programChain) ||
          this.isAllowedToViewProgramChainsWithUndefinedProgramNumber
        ) 
      )
      .map((programChain) => {
        const projectAssignmentDetailsOfProgramChain = getProjectAssignmentDetailsOfProgramChain(
          programChain,
          this.currentProjectAssignmentDetails
        );


        const assignmentInfo = 
          projectAssignmentDetailsOfProgramChain ?? getProjectAssignmentDetailsFromClientPanelAssignments(
            programChain.assignmentId,
            this.clientPanelAssignments
          );

        return {
          programChain: programChain,
          projectAssignmentDetails: assignmentInfo,
        };
      });
  }

  get isInfiteLoadingEnabled() {
    return this.canLoadMoreProgramChains;
  }

  async infiniteHandler(data: StateChanger) {
    if (!this.canLoadMoreProgramChains) {
      data.complete();
    }

    await this.loadNextProgramChains();

    if (this.canLoadMoreProgramChains) {
      data.loaded();
    } else {
      data.complete();
    }
  }

  async loadNextProgramChains() {
    const iresDevice = this.iresDevice;
    if (!iresDevice) {
      return;
    }

    this.isLoading = true;

    const {
      canLoadMore,
      programChains,
      nextPaginationDate,
    } = await loadProgramChains(
      iresDevice.serialNo,
      20,
      this.nextPaginationDate
    );

    this.programChains.push(
      ...programChains.filter(
        //Active program chain should not be displayed in history
        (chain) => !isActiveProgramChainOfIresDevice(iresDevice, chain)
      )
    );

    this.nextPaginationDate = nextPaginationDate;

    this.canLoadMoreProgramChains = canLoadMore;
    this.isLoading = false;
  }

  calculateBackgroundStyle(programChainId: string) {
    return calculateBackgroundStyle(programChainId, StorageKeyLastVisitedItemLevel.LEVEL_4);
  }
}
